import React from 'react';
import { useViewlogies } from 'context';
import { FormattedMessage } from 'react-intl';
import m from './messages';
import './videoNavigation.scss';

const VideoNavigation = () => {
    const {
        event: { color, memorialMomentsUrl },
        streams,
        streamIndex,
        setStreamIndex,
    } = useViewlogies();

    const selectedStyle = {
        color,
        borderBottom: `2px solid ${color}`,
    };

    const isTabSelected = tabIndex => streamIndex === tabIndex;

    // let tabOffset = 0;

    return (
        <div className="streams-navigation">
            {memorialMomentsUrl && (
                <div
                    className={`stream-tab${isTabSelected(-1) ? ' selected' : ''}`}
                    style={isTabSelected(-1) ? selectedStyle : {}}
                    onClick={() => setStreamIndex(-1)}
                    key={-1}
                >
                    <FormattedMessage {...m['Memorial Moments']} />
                </div>
            )}

            {streams.map((stream, index) => {
                return (
                    <div
                        className={`stream-tab${isTabSelected(index) ? ' selected' : ''}${streams.length === 1 && !memorialMomentsUrl ? ' single' : ''}`}
                        style={isTabSelected(index) ? selectedStyle : {}}
                        onClick={() => setStreamIndex(index)}
                        key={index}
                    >
                        {m[stream.name] ? <FormattedMessage {...m[stream.name]} /> : stream.name}
                    </div>
                );
            })}
        </div>
    );
};

export default VideoNavigation;
